import type { ExamineeRegistrationStatus } from '@exam-center/graphql';
import { Label, LabelColor } from '@shared/components';

export type RegistrationStatusLabelVariants = ExamineeRegistrationStatus;

export const REGISTRATION_STATUS_COLOR: Readonly<
  Record<RegistrationStatusLabelVariants, LabelColor>
> = {
  REGISTERED: LabelColor.SUCCESS,
  FAILED: LabelColor.ERROR,
  NOT_REGISTERED: LabelColor.GREY,
};

export const REGISTRATION_STATUS_TEXT: Readonly<Record<RegistrationStatusLabelVariants, string>> = {
  REGISTERED: 'ลงทะเบียนเรียบร้อย',
  NOT_REGISTERED: 'ยังไม่ได้ลงทะเบียน',
  FAILED: 'ลงทะเบียนไม่สำเร็จ',
};

interface RegistrationStatusLabelProps {
  variant: RegistrationStatusLabelVariants;
}

export default function RegistrationStatusLabel(props: Readonly<RegistrationStatusLabelProps>) {
  const { variant } = props;

  return (
    <Label
      color={REGISTRATION_STATUS_COLOR[variant]}
      sx={(theme) => ({
        borderRadius: theme.shape.rounded(1.5),
        p: theme.spacing(1, 3),
      })}
    >
      {REGISTRATION_STATUS_TEXT[variant]}
    </Label>
  );
}
